<template>
  <div>
    <p class="m-5">
      Let your team members know that you are all set by inviting them to join your virtual team and welcome them.
    </p>
    <div class="pb-4">
      <b-link v-if="!invitationLink" variant="link" :disabled="gettingLink" class="btn-link-dark" @click.prevent="onGetInviteLink">
        <b-icon-link45deg font-scale="1.2" /> Get an invite link to share
      </b-link>
      <b-form-row v-else class="align-items-center">
        <b-col>
          <b-form-input ref="inviteLink" v-focus v-model="invitationLink" readonly class="rounded-pill" @focus="onFocus" />
        </b-col>
        <b-col cols="1">
          <b-button variant="link" class="btn-link-primary p-0" @click.prevent="onCopyInviteLink">
            <b-icon-files font-scale="1.5" />
          </b-button>
        </b-col>
      </b-form-row>
    </div>
    <invitation-users-form :submitting="submitting" :team="team" :max="maxInvitations" @submit="onInviteUserSubmit" />
  </div>
</template>

<script>
import { BIconLink45deg, BIconFiles } from 'bootstrap-vue'
import InvitationUsersForm from '@/components/forms/InvitationUsersForm'
import { toastError } from '@/helpers/helpers'

export default {
  name: 'InvitationUsers',

  props: {
    team: {
      type: Object,
      required: true
    },

    maxInvitations: {
      type: Number,
      default: 20
    }
  },

  data() {
    return {
      invitationLink: null,
      gettingLink: false,
      submitting: false
    }
  },

  methods: {
    onInviteUserSubmit(data) {
      this.submitting = true
      this.$store.dispatch('inviteUsers', data)
        .then(() => this.$emit('submitted'))
        .catch(() => toastError(this))
        .finally(() => { this.submitting = false })
    },

    onGetInviteLink() {
      this.gettingLink = true
      this.$store.dispatch('getInvitationLink', this.team.id)
        .then(({ link }) => (this.invitationLink = link))
        .finally(() => (this.gettingLink = false))
    },

    onFocus({ target }) {
      target.select()
      target.setSelectionRange(0, target.value.length)
    },

    onCopyInviteLink() {
      const input = this.$refs.inviteLink.$el
      input.select()
      input.setSelectionRange(0, input.value.length)
      document.execCommand('copy')
    }
  },

  components: {
    InvitationUsersForm,
    BIconLink45deg,
    BIconFiles
  }
}
</script>
